import {
    Breadcrumbs,
    Button,
    Card,
    CardActions,
    CardContent,
    Checkbox,
    Chip,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    Link,
    MenuItem,
    Select,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { DateTimePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { useDispatch, useSelector } from "react-redux";
import { ERoles } from "../../../../config";
import useAuth from "../../../../hooks/useAuth";
import { setErrorMessageForUser, setShowAddApikeyForm } from "../../../../redux/userManagement/userManagementSlice";
import { addApikeysForResellersThunk } from "../../../../redux/userManagement/userManagementThunk";
import { apiGatewayAxiosInstance } from "../../../../utils/axios";
import AddIpstoApikey from "./AddIPstoApikey";
import AddIPstoApikey from "./AddIPstoApikey";
import SearchableDropdown from "../../../mis/SearchableDropdown";

export default function AddApiKeys({ setOperationStatus }) {
    const state = useSelector(state => state.userManagementSlice);
    const dispatch = useDispatch();
    const [resellerData, setResellerData] = useState();
    const [selectedResellerData, setSelectedResellerData] = useState({});
    const [selectedOrgData, setSelectedOrgData] = useState({});
    const [orgData, setOrgData] = useState();
    const [apiPermissions, setApiPermissions] = useState();
    const [checked, setChecked] = useState(false);
    const [validTill, setValidTill] = useState(null);
    const [apiKey, setApiKey] = useState("");
    const [copySuccess, setCopySuccess] = useState(false);
    const currentDateTime = new Date();
    const [selectedDate, setSelectedDate] = useState(currentDateTime);
    const { user } = useAuth();
    const roleName = user?.roleName;
    const [openAddIpAddress, setOpenAddIpAddress] = useState(false);
    const [ipAddresses, setIPAddresses] = useState(["0.0.0.0"]);
    const [clientListForSuperAdmin, setClientListForSuperAdmin] = useState([]);

    const validatingApiKeyData = () => {
        let result = true;
        if (roleName === "super_admin" && formik.values.resellerName === "" && formik.values.orgName === "") {
            result = false;
            formik.setFieldError("resellerName", `Reseller Name is required`);
        }
        if (roleName === "reseller_admin" && formik.values.orgName === "") {
            result = false;
            formik.setFieldError("orgName", `Organization Name is required`);
        }

        return result;
    };

    const formik = useFormik({
        initialValues: {
            resellerName: "",
            orgName: "",
            registryId: null,
            orgId: null,
            apiKey: "",
            description: "",
            permissions: [],
            ipAddresses:
                user?.roleName === ERoles.SUPER_ADMIN
                    ? selectedResellerData?.ipAddresses
                        ? selectedResellerData?.ipAddresses
                        : []
                    : selectedOrgData?.ipAddresses
                    ? selectedOrgData.ipAddresses
                    : [],
            isInfinite: true,
            validTill: "",
        },
        validate: values => {
            const errors = {};

            if (roleName === "super_admin" && !values.resellerName && !values.orgName) {
                errors.resellerName = "Reseller Name is required";
            }
            if (roleName === "reseller_admin" && !values.orgName) {
                errors.orgName = "Organization Name is required";
            }

            if (!values.description) {
                errors.description = "Description is required";
            }

            if (!values.apiKey) {
                errors.apiKey = "API Key is required";
            }

            if (checked && !values.validTill) {
                errors.validTill = "Valid till date is required!";
            }

            if (checked && values.validTill) {
                const currentDate = new Date();
                if (values.validTill < currentDate) {
                    errors.validTill = "Valid till date cannot be previous date!";
                }
            }
            return errors;
        },
        onSubmit: async (values, { setErrors, setStatus, setSubmitting, resetForm }) => {
            try {
                const validate = validatingApiKeyData();
                if (validate) {
                    const dataToSend = {
                        resellerName: values.resellerName,
                        registryId: values.registryId,
                        orgName: values.orgName,
                        orgId: values.orgId,
                        apiKey: values.apiKey,
                        description: values.description,
                        permissions: values.permissions,
                        ipAddresses: ipAddresses,
                        isInfinite: values.isInfinite,
                        validTill: values.validTill,
                    };
                    dispatch(
                        addApikeysForResellersThunk({
                            data: dataToSend,
                        }),
                    )
                        .unwrap()
                        .then(() => {
                            setOperationStatus({
                                message: "ApiKey Created Successfully.",
                                success: true,
                                failed: false,
                            });
                        });
                }
            } catch (error) {
                const message = formik.errors.message || "Something went wrong";
                setStatus({ success: false });
                setErrors({ submit: message });
                setSubmitting(false);
            }
        },
        validateOnChange: false,
        validateOnBlur: false,
    });

    const onChangeReseller = e => {
        const { value } = e.target;
        const resellerDetails = resellerData.find(reseller => reseller._id === value);
        if (resellerDetails) {
            formik.setFieldValue("registryId", resellerDetails._id);
            formik.setFieldValue("resellerName", resellerDetails.resellerName);
            formik.setFieldValue("resellerId", resellerDetails._id);
            getSelectedResellerData(resellerDetails._id);
        }
    };

    const onChangeOrganization = e => {
        const { value } = e.target;
        const orgDetails = orgData.find(org => org._id === value);
        if (orgDetails) {
            formik.setFieldValue("registryId", user.registryId);
            formik.setFieldValue("resellerName", user.resellerName);
            formik.setFieldValue("orgId", orgDetails._id);
            formik.setFieldValue("orgName", orgDetails.orgName);
            getSelectedOrganizationData(orgDetails._id);
        }
    };

    const onChangeOrgForSuperAdmin = e => {
        const { value } = e.target;
        const orgDetails = clientListForSuperAdmin.find(org => org._id === value);
        if (orgDetails) {
            formik.setFieldValue("orgId", orgDetails._id);
            formik.setFieldValue("orgName", orgDetails.orgName);
            getSelectedOrganizationData(orgDetails._id);
        }
    };

    const handleCheckboxChange = event => {
        formik.setFieldValue("isInfinite", !event.target.checked);
        setChecked(event.target.checked);
        if (event.target.checked) {
            setValidTill(null);
        }
    };

    const handleDateChange = (date, event) => {
        setSelectedDate(date);
    };

    const getAllResellers = async () => {
        try {
            const response = await apiGatewayAxiosInstance.get(`/user_management/clients/get-all-resellers-for-dropdown`);
            setResellerData(response.data.data);
        } catch (error) {
            let errorMessage = "Server not reachable.";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            dispatch(
                setErrorMessageForUser({
                    fieldName: "getClientEditDetailsErrorMessages",
                    errorMessage,
                }),
            );
        }
    };

    const getAllOrgForSuperAdmin = async () => {
        const response = await apiGatewayAxiosInstance.get(`/user_management/organization/get-all-active-org-by-registryId`, {});
        if (response.status === 200) {
            const clientList = response.data.data;
            setClientListForSuperAdmin(clientList);
        } else {
            throw new Error(response);
        }
    };

    const getAllOrganization = async () => {
        try {
            const registryId = user?.registryId;
            const response = await apiGatewayAxiosInstance.get(`/user_management/clients/get-all-org-for-dropdown`, {
                params: { registryId },
            });
            setOrgData(response.data.data);
        } catch (error) {
            let errorMessage = "Server not reachable.";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
        }
    };

    const getAllApiPermissions = async () => {
        try {
            const response = await apiGatewayAxiosInstance.get(`/user_management/user-permission/get-all`);
            setApiPermissions(response.data.data);
        } catch (error) {
            let errorMessage = "Server not reachable.";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            dispatch(
                setErrorMessageForUser({
                    fieldName: "getClientEditDetailsErrorMessages",
                    errorMessage,
                }),
            );
        }
    };

    const onClickCancelButton = e => {
        dispatch(setShowAddApikeyForm(false));
    };

    // const handleGenerateApiKey = async () => {
    //     try {
    //         const generatedKey = uuidv4()
    //         setApiKey(generatedKey);
    //         formik.setFieldValue('apiKey', generatedKey);
    //     } catch (error) {
    //         let errorMessage = "Server not reachable.";

    //         if (error.response) {
    //             errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
    //         }
    //         dispatch(
    //             setErrorMessageForUser({
    //                 fieldName: "getClientEditDetailsErrorMessages",
    //                 errorMessage,
    //             }),
    //         );
    //     }
    // }

    const getSelectedResellerData = async registryId => {
        try {
            const response = await apiGatewayAxiosInstance.get(`/user_management/clients/reseller-data-by-id`, {
                params: { registryId },
            });
            setSelectedResellerData(response.data.data);
            if (response?.data?.data?.ipAddresses) {
                formik.setFieldValue("ipAddresses", response.data.data.ipAddresses);
                // setIPAddresses(response.data.data.ipAddresses);
            } else {
                formik.setFieldValue("ipAddresses", []);
            }
        } catch (error) {
            let errorMessage = "Server not reachable.";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            dispatch(
                setErrorMessageForUser({
                    fieldName: "getClientEditDetailsErrorMessages",
                    errorMessage,
                }),
            );
        }
    };

    const getSelectedOrganizationData = async orgId => {
        try {
            const response = await apiGatewayAxiosInstance.get(`/user_management/clients/org-data-by-id`, {
                params: { orgId },
            });
            setSelectedOrgData(response.data.data);
            if (response?.data?.data?.ipAddresses) {
                formik.setFieldValue("ipAddresses", response.data.data.ipAddresses);
                // setIPAddresses(response.data.data.ipAddresses);
            } else {
                formik.setFieldValue("ipAddresses", []);
            }
            return;
        } catch (error) {
            let errorMessage = "Server not reachable.";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            dispatch(
                setErrorMessageForUser({
                    fieldName: "getClientEditDetailsErrorMessages",
                    errorMessage,
                }),
            );
        }
    };

    const handleGenerateApiKey = async () => {
        try {
            const response = await apiGatewayAxiosInstance.post(`/user_management/apikeys/create-apikey`);
            if (response.status === 200) {
                const apiKey = response.data.apiKey;
                setApiKey(apiKey);
                formik.setFieldValue("apiKey", apiKey);
            }
        } catch (error) {
            let errorMessage = "Server not reachable.";
            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            dispatch(
                setErrorMessageForUser({
                    fieldName: "getClientEditDetailsErrorMessages",
                    errorMessage,
                }),
            );
        }
    };

    const handleClose = () => {
        setOpenAddIpAddress(false);
    };

    const handleAddIPAddress = () => {
        setOpenAddIpAddress(true);
    };

    const handleCopyApiKey = () => {
        setCopySuccess(true);
        setTimeout(() => {
            setCopySuccess(false);
        }, 2000);
    };

    useEffect(() => {
        getAllResellers();
        getAllOrganization();
        getAllApiPermissions();
        if (user.roleName === ERoles.SUPER_ADMIN) {
            getAllOrgForSuperAdmin();
        }
    }, [user]);

    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid item md={6} display={"flex"} alignItems={"center"}>
                <IconButton color="secondary" onClick={onClickCancelButton} size="medium">
                    <ArrowBackIosIcon sx={{ cursor: "pointer" }} />
                </IconButton>

                <Grid role="presentation">
                    <Breadcrumbs aria-label="breadcrumb" fontSize="large">
                        <Link underline="hover" color="inherit" className="breadcrumbItem breadcrumbFontSize" onClick={onClickCancelButton}>
                            API Keys
                        </Link>
                        <Typography className="breadcrumbItem" color="text.primary">
                            Add New API Key
                        </Typography>
                    </Breadcrumbs>
                </Grid>
            </Grid>
            <Card sx={{ padding: "0.8rem" }}>
                <CardContent sx={{ padding: "10px" }}>
                    <Grid className="d-flex" gap={5}>
                        <Grid sx={{ display: "flex" }} width={"50%"}>
                            {roleName === "super_admin" ? (
                                <>
                                    <FormControl fullWidth error={Boolean(formik.errors.resellerName && formik.touched.resellerName)}>
                                        <SearchableDropdown
                                            dropDownList={resellerData}
                                            value={formik.values.resellerId}
                                            handleChange={onChangeReseller}
                                            disabled={false}
                                            label="Select Reseller"
                                            size="small"
                                            name="resellerId"
                                            placeholder="Search Reseller..."
                                            valueKey="_id"
                                            dropDownValueKey="resellerName"
                                            showAllOption={false}
                                        />

                                        <FormHelperText>{formik?.errors?.resellerName}</FormHelperText>
                                    </FormControl>
                                    <FormControl fullWidth>
                                        <SearchableDropdown
                                            dropDownList={clientListForSuperAdmin}
                                            value={formik.values.orgId}
                                            handleChange={onChangeOrgForSuperAdmin}
                                            disabled={false}
                                            label="Select Organization"
                                            size="small"
                                            name="orgId"
                                            placeholder="Search Organization..."
                                            valueKey="_id"
                                            dropDownValueKey="orgName"
                                            showAllOption={false}
                                        />
                                    </FormControl>
                                </>
                            ) : (
                                <FormControl fullWidth>
                                    <SearchableDropdown
                                        dropDownList={orgData}
                                        value={formik.values.orgId}
                                        handleChange={onChangeOrganization}
                                        disabled={false}
                                        label="Select Organization"
                                        size="small"
                                        name="orgId"
                                        placeholder="Search Organization..."
                                        valueKey="_id"
                                        dropDownValueKey="orgName"
                                        showAllOption={false}
                                    />
                                </FormControl>
                            )}
                        </Grid>
                        <Grid sx={{ display: "flex" }} width={"50%"}>
                            <FormControl fullWidth error={Boolean(formik.errors.description)}>
                                <TextField
                                    fullWidth
                                    name="description"
                                    label="Description"
                                    variant="outlined"
                                    error={Boolean(formik.errors.description)}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.description}
                                    onChange={formik.handleChange}
                                    inputProps={{ maxLength: 200 }}
                                />
                                <FormHelperText>{formik?.errors?.description}</FormHelperText>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid className="d-flex" sx={{ width: "50%", display: "flex", justifyContent: "space-between" }} mt={4}>
                        <Grid sx={{ width: "80%", display: "flex", alignItems: "center" }}>
                            <FormControl sx={{ width: "90%" }} error={Boolean(formik.errors.apiKey)}>
                                <TextField
                                    name="generatedapikey"
                                    id="generated apikey"
                                    label="Generated Api Key"
                                    variant="outlined"
                                    value={apiKey}
                                    error={Boolean(formik.errors.apiKey && formik.touched.apiKey)}
                                    helperText={formik.errors.apiKey && formik.touched.apiKey ? formik.errors.apiKey : ""}
                                    fullWidth
                                    disabled
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                {apiKey && (
                                                    <CopyToClipboard text={apiKey} onCopy={handleCopyApiKey}>
                                                        <Tooltip title={copySuccess ? "Copied!" : "Copy to clipboard"}>
                                                            <IconButton color="primary" size="small">
                                                                <ContentCopyIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </CopyToClipboard>
                                                )}
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid sx={{ width: "20%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <Button variant="contained" color="primary" onClick={handleGenerateApiKey} size="small">
                                Generate API Key
                            </Button>
                        </Grid>
                    </Grid>

                    <Grid className="d-flex" mt={3}>
                        <FormControlLabel
                            control={<Checkbox checked={checked} onChange={handleCheckboxChange} name="addApikey" fontSize="small" />}
                            label="Add Validity for apikey"
                        />

                        {checked && (
                            <Grid item xs={12} mt={3}>
                                <FormControl fullWidth error={Boolean(formik.errors.validTill)}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DateTimePicker
                                            label="Select Valid till"
                                            value={formik.values.validTill || null}
                                            onChange={(date, event) => {
                                                handleDateChange(date, event);
                                                formik.setFieldValue("validTill", date);
                                            }}
                                            minDateTime={
                                                selectedDate &&
                                                selectedDate.getDate() === currentDateTime.getDate() &&
                                                selectedDate.getMonth() === currentDateTime.getMonth() &&
                                                selectedDate.getFullYear() === currentDateTime.getFullYear()
                                                    ? new Date(
                                                          currentDateTime.getFullYear(),
                                                          currentDateTime.getMonth(),
                                                          currentDateTime.getDate(),
                                                          currentDateTime.getHours(),
                                                          currentDateTime.getMinutes(),
                                                      ) // Restrict to current date and time
                                                    : new Date(currentDateTime.getFullYear(), currentDateTime.getMonth(), currentDateTime.getDate()) // Allow any time for future dates
                                            }
                                            renderInput={params => <TextField {...params} />}
                                            error={Boolean(formik.errors.validTill)}
                                            helperText={formik.errors.validTill && formik.touched.validTill ? formik.errors.validTill : ""}
                                        />
                                    </LocalizationProvider>
                                    <FormHelperText>
                                        {formik.errors.validTill && formik.touched.validTill ? formik.errors.validTill : ""}
                                    </FormHelperText>
                                </FormControl>
                            </Grid>
                        )}
                    </Grid>
                    <Grid mt={4}>
                        {/* Add ipAddress to apikeys */}

                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={handleAddIPAddress}
                            disabled={!formik.values.resellerName && !formik.values.orgName}
                        >
                            Add IP Adresses
                        </Button>

                        <Grid item padding={2} md={6} mt={4}>
                            <Typography className="text-muted mb-2">List of IPAddresses added :</Typography>
                            <div>
                                {ipAddresses &&
                                    ipAddresses.length > 0 &&
                                    ipAddresses?.map((item, index) => <Chip size="small" label={item} sx={{ margin: "4px" }} />)}
                            </div>
                        </Grid>
                    </Grid>
                </CardContent>
                {openAddIpAddress && (
                    <AddIPstoApikey
                        open={openAddIpAddress}
                        handleClose={handleClose}
                        formik={formik}
                        selectedResellerData={selectedResellerData}
                        selectedOrgData={selectedOrgData}
                        roleName={roleName}
                        ipAddresses={ipAddresses}
                        setIPAddresses={setIPAddresses}
                    />
                )}
                <CardActions sx={{ padding: "0px" }}>
                    <Grid container sx={{ alignItems: "center" }}>
                        <Grid item>
                            <Button variant="contained" color="primary" className="m-2" type="submit">
                                Submit
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" color="error" onClick={onClickCancelButton} className="m-2">
                                Cancel
                            </Button>
                        </Grid>
                    </Grid>
                </CardActions>
            </Card>
        </form>
    );
}
